import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import pkg from '../../../package.json';
import { InfoCard } from '../../components/infoCard/InfoCard.component';
import { GameContext } from '../../core/context/game.context';
import { configDataLayer, pushGtmDataLayer } from '../../core/helper/gtm.helper';
import { safeImageImport } from '../../core/helper/image.helper';
import { randomHelper } from '../../core/helper/random.helper';
import { IInstanceInfo, PresetId } from '../../core/interfaces/instaces.interfaces';
import './landing.style.scss';

export const Landing = (p: { instancesInfos: IInstanceInfo[] }) => {
  const gameCtx = useContext(GameContext);
  const [styleState, setStyleState] = useState({ section: null });
  const mediaQuery = window.matchMedia('(max-width: 767.98px)');
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const manageBg = (arg: MediaQueryListEvent, rndValue: number) => {
    const size = arg.matches ? 'small' : 'big';

    setStyleState((state) => ({
      ...state,
      section: { backgroundImage: `url(${safeImageImport(`assets/images/general/bg/${size}/0${rndValue}`)})` },
    }));
  };

  useEffect(() => {
    const rndValue = randomHelper(1);
    const changeHandler = (e: MediaQueryListEvent) => manageBg(e, rndValue);

    manageBg({ matches: mediaQuery.matches } as MediaQueryListEvent, rndValue);
    mediaQuery.addEventListener('change', changeHandler);
    gameCtx.deleteGame();
    return () => mediaQuery.removeEventListener('change', changeHandler);
  }, []);

  const clickHandler = (presetId: PresetId, instInfo: IInstanceInfo) => {
    const preset = instInfo.presets.find((p) => p.id === presetId);
    gameCtx.setScore(0);
    navigate(`./${instInfo.id}/${instInfo.name}/${preset.id}/${preset.name}/game`);
    configDataLayer(i18n.language, instInfo.name, preset.name);
    pushGtmDataLayer('gameStart');
  };

  return (
    <section className="LandingComponent" style={styleState.section}>
      <div className="LandingComponent__aligner--columned">
        <div className="LandingComponent__aligner__child LandingComponent__aligner__child--fullWidth">
          <div className="LandingComponent__header">
            <p className="LandingComponent__header__text">{t('landing.title')}</p>
          </div>
        </div>
        {[...p.instancesInfos].reverse().map((instInfo, idx) => (
          <div key={idx} className="LandingComponent__aligner__child LandingComponent__aligner__child--fullWidth">
            <div className="LandingComponent__infoWrapper">
              <InfoCard instanceInfo={instInfo} onClick={(e) => clickHandler(e, instInfo)} />
            </div>
          </div>
        ))}
      </div>
      <div className="LandingComponent__footer">v{pkg.version}</div>
    </section>
  );
};
